import { Navigate } from "react-router-dom";
import React from "react";
import { useJumboApp } from "@jumbo/hooks";
import { config } from "app/config/main";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import Loading from "app/pages/components/Loading";

function AdminRoute({
  component,
  MainComponent,
  layout,
  ...props
}) {
  const { activeLayout, setActiveLayout } = useJumboApp();
  const { authUser, isLoading } = useJumboAuth();

  React.useEffect(() => {
    if (layout !== activeLayout) {
      setActiveLayout(layout);
    }
  }, [layout, activeLayout, setActiveLayout]);

  // Aguardar restauração da sessão antes de decidir
  if (isLoading) {
    return <Loading />;
  }

  if (authUser?.role !== 'ADMIN') {
    return <Navigate to="/" />;
  }

  return <MainComponent component={component} {...props} />;
}

AdminRoute.defaultProps = {
  layout: config.defaultLayout,
};

export default AdminRoute;